import StyledModal from "./StyledModal";

export default StyledModal;

export * from "./StyledModal";
